
import { useState, useEffect } from 'react';

interface VisitorInfo {
  ip: string;
  city: string;
  region: string;
  country: string;
  timezone: string;
  browser: string;
  userAgent: string;
}

export const useVisitorTracking = () => {
  const [visitorInfo, setVisitorInfo] = useState<VisitorInfo | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchVisitorInfo = async () => {
    try {
      const response = await fetch('https://ipinfo.io?token=fdb6cbddb142df');
      const data = await response.json();
      
      const browser = getBrowserInfo();
      
      const info: VisitorInfo = {
        ip: data.ip || 'Unknown',
        city: data.city || data.region || 'Unknown',
        region: data.region || 'Unknown',
        country: data.country || 'Unknown',
        timezone: data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
        browser: browser,
        userAgent: navigator.userAgent
      };
      
      setVisitorInfo(info);
      return info;
    } catch (error) {
      console.error('Failed to fetch visitor info:', error);
      
      // Fallback info
      const fallbackInfo: VisitorInfo = {
        ip: 'Unknown',
        city: 'Unknown',
        region: 'Unknown',
        country: 'Unknown',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        browser: getBrowserInfo(),
        userAgent: navigator.userAgent
      };
      
      setVisitorInfo(fallbackInfo);
      return fallbackInfo;
    } finally {
      setIsLoading(false);
    }
  };

  const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;
    let browser = 'Unknown';
    
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
      browser = 'Chrome';
    } else if (userAgent.includes('Firefox')) {
      browser = 'Firefox';
    } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
      browser = 'Safari';
    } else if (userAgent.includes('Edg')) {
      browser = 'Edge';
    } else if (userAgent.includes('Opera')) {
      browser = 'Opera';
    }
    
    return browser;
  };

  useEffect(() => {
    fetchVisitorInfo();
  }, []);

  return {
    visitorInfo,
    isLoading,
    refreshVisitorInfo: fetchVisitorInfo
  };
};
